import { batch } from 'solid-js'
import { useEntityGridXYV2Memo } from '../../../rx/memo/useEntityGridXYV2Memo'
import { useHoveredPositionSignal } from '../../../rx/signal/useHoveredPositionSignal'
import { useLastTouchMoveEventSignal } from '../../../rx/signal/useLastTouchMoveEventSignal'
import { useSelectedPositionSignal } from '../../../rx/signal/useSelectedPositionSignal'
import { useSelectedToolSignal } from '../../../rx/signal/useSelectedToolSignal'
import { useTouchEndEventSignal } from '../../../rx/signal/useTouchEndEventSignal'
import { useTouchStartEventSignal } from '../../../rx/signal/useTouchStartEventSignal'
import { useTouchStartPositionSignal } from '../../../rx/signal/useTouchStartPositionSignal'
import { useTouchDragList } from '../../../rx/use/useTouchDragList'
import calculateDestPositionHoverPositionPaths from '../../core/draft_move/calculateDestPositionHoverPositionPaths'
import calculateDraftMoveAttackEstimates from '../../core/draft_move/calculateDraftMoveAttackEstimates'
import { Engine } from '../../core/engine/Engine.type'
import calculateSelectedPositionEnts from '../../core/entity/calculateSelectedPositionEnts'
import { SelectedToolId } from '../../core/map_editor/SelectedToolId.enum'
import { createEraseTileAction } from '../../core/state/flux/action/Map/EraseTileAction'
import { createPaintTileAction } from '../../core/state/flux/action/Map/PaintTileAction'
import dispatchClient from '../../core/state/flux/dispatchClient'
import isPositionInBounds from '../../core/tile_position_xy/isPositionInBounds'
import { samePosition } from '../../core/tile_position_xy/samePosition'
import { emitEvent } from '../../event/event'
import { actionBindings } from '../../event/InputRouter/actionBindings'
import getInputActionListenerList from '../../event/InputRouter/getInputActionListenerList'
import touchClickEventMatchesInputActionBinding from '../../event/InputRouter/touchClickEventMatchesInputActionBinding'
import onElementEvent from '../../onElementEvent'
import { usePaintTileOptionSignal } from '../../../rx/signal/usePaintTileOptionSignal'
import { useEraseTileOptionSignal } from '../../../rx/signal/useEraseTileOptionSignal'
import { useSelectedPlayerIdSignal } from '../../../rx/signal/useSelectedPlayerIdSignal'

export default function registerTouchEventsV2(engine: Engine, elem: HTMLElement) {
  const [getTouchStartEvent, setTouchStartEvent] = useTouchStartEventSignal(engine)
  const [getTouchStartPosition, setTouchStartPosition] = useTouchStartPositionSignal(engine)
  const [getSelectedTool] = useSelectedToolSignal(engine)
  const [, setSelectedPosition] = useSelectedPositionSignal(engine)
  const [, setHoveredPosition] = useHoveredPositionSignal(engine)
  const [getLastTouchMoveEvent, setLastTouchMoveEvent] = useLastTouchMoveEventSignal(engine)
  const [, setTouchEndEvent] = useTouchEndEventSignal(engine)
  const touchDragList = useTouchDragList(engine)

  const getEntityGridXYV2 = useEntityGridXYV2Memo(engine)

  function onTouchStart(event: TouchEvent) {
    // this preventDefault stops the browser from interpretting
    // swipe left/right as navigate history forward/backward
    // it also breaks touching regular DOM elements as touch events
    // but htmlbody{overscroll-behavior-x: none} appears to have worked.
    // event.preventDefault()

    event.stopPropagation()
    // if (wasTargetNotCanvas(event.target)) {
    //   onTouchCancel(event)
    //   return
    // }
    const touchesLen = event.touches.length
    if (touchesLen === 1) {
      // console.log('onTouchStart.single', event)
      // const touch: Touch = event.touches[0]
      // const { clientX, clientY } = touch
      // const touchPosition = positionFromPixels(state, viewCtx, clientX, clientY) // pre-threejs
      // setHoveredPosition(touchPosition)
      // engine.selectedPosition = touchPosition
      // calculateSelectedPositionEnts(engine)

      // const touch: Touch = event.touches[0]
      // const { clientX, clientY } = touch

      batch(() => {
        setSelectedPosition(null)
        calculateSelectedPositionEnts(engine)
      })
      setTouchStartEvent(event)
      // const position = positionFromPixels(engine.state, engine.viewCtx, clientX, clientY) // pre-threejs
      const position = null
      setTouchStartPosition(position)
      setTouchEndEvent(null)
      touchDragList.length = 0
      // dirty(EngineCache.Cursor)
    }
    setLastTouchMoveEvent(null)
  }

  function onTouchMove(event: TouchEvent) {
    event.preventDefault()
    event.stopPropagation()
    // if (wasTargetNotCanvas(event.target)) {
    //   onTouchCancel(event)
    //   return
    // }

    const prevLastTouchMoveEvent = getLastTouchMoveEvent()
    const touchesLen: number = event.touches.length
    const prevTouchesLen: number = prevLastTouchMoveEvent?.touches.length || 0

    if (touchesLen !== prevTouchesLen) {
      // if a finger drops or is added, do nothing
      // let next event continue
    } else if (touchesLen === 1) {
      // Single touch - pan
      // const touch: Touch = event.touches[0]
      // const { clientX, clientY } = touch
      // const devicePixelRatio = window.devicePixelRatio || 1
      // const previousTouch = prevLastTouchMoveEvent?.touches[0]

      // const touchPosition = positionFromPixels(state, viewCtx, clientX, clientY) // pre-threejs
      // setHoveredPosition(touchPosition)
      // engine.selectedPosition = touchPosition
      // calculateSelectedPositionEnts(engine)
    } else if (touchesLen === 2) {
      // threejs MapControls handles this
    }

    setLastTouchMoveEvent(event)
  }

  function onTouchEnd(event: TouchEvent) {
    // event.preventDefault()
    event.stopPropagation()
    // if (wasTargetNotCanvas(event.target)) {
    //   onTouchCancel(event)
    //   return
    // }
    const touchesLen = event.touches.length
    // if (touchesLen === 1) {
    //   console.log('onTouchEnd.single', event)
    //   const touch: Touch = event.touches[0]
    //   const { clientX, clientY } = touch
    //   const touchPosition = positionFromPixels(state, viewCtx, clientX, clientY) // pre-threejs
    //   setHoveredPosition(touchPosition)
    //   engine.selectedPosition = touchPosition
    //   calculateSelectedPositionEnts(engine)
    // }
    if (touchesLen === 1) {
      // console.log('onTouchEnd.single', event)
      // const touch: Touch = event.touches[0]
      setTouchEndEvent(event)
      // const { offsetX, offsetY } = event
      // const { clientX, clientY } = touch
      const touchStartEvent = getTouchStartEvent()
      const touchStartPosition = getTouchStartPosition()

      // const isDrag: boolean = touchDragMetThreshold(touchDragList, viewCtx.tile_size)
      const isDrag: boolean = false
      // console.log('touch.isDrag', isDrag)

      // a long press should be treated like a right click
      // right click is undefined behavior
      // @todo make isLongPress not true for pans
      const clickDuration = touchStartEvent ? (event.timeStamp - touchStartEvent.timeStamp) : null
      const isLongPress = clickDuration ? clickDuration > 500 : false
      // a click is a mouse down + mouse up event that occurs in less than 500 ms
      const isClick = touchStartEvent && !isLongPress && !isDrag

      const selectedTool = getSelectedTool()
      const position = null
      // const position = positionFromPixels(engine.state, viewCtx, clientX, clientY) // pre-threejs
      // console.log('onMouseUp.position', position)
      // if (isLongPress) {
      //   // console.log('onTouchEnd.isLongPress')
      // } else
      if (isClick) {
        if (selectedTool === SelectedToolId.Inspect) {
          if (isPositionInBounds(position, engine) && samePosition(touchStartPosition, position)) {
            // console.log('engine.selectedPosition =', position)
            setSelectedPosition(position)
          } else {
            // console.log('engine.selectedPosition = to NULL')
            setSelectedPosition(null)
          }
          calculateSelectedPositionEnts(engine)
          // dirty(EngineCache.SelectedPosition)
        } else if (selectedTool === SelectedToolId.Paint) {
          // console.log('position', position)
          if (position && samePosition(touchStartPosition, position)) {
            const [getPaintTileOption] = usePaintTileOptionSignal(engine)
            const [getSelectedPlayerId] = useSelectedPlayerIdSignal(engine)
            dispatchClient(
              engine,
              createPaintTileAction(getPaintTileOption(), position, getSelectedPlayerId())
            )
          }
        } else if (selectedTool === SelectedToolId.Erase) {
          if (position && samePosition(touchStartPosition, position)) {
            const [getEraseTileOption] = useEraseTileOptionSignal(engine)
            dispatchClient(engine, createEraseTileAction(getEraseTileOption(), position))
          }
        } else {
          // console.log('isClick.SelectedToolId.Else')
          for (let i = 0; i < actionBindings.length; i++) {
            const { action, input } = actionBindings[i]
            // console.log('onMouseUp.isClick.isMatch', touchClickEventMatchesInputActionBinding(event, input), actionBindings[i])
            if (touchClickEventMatchesInputActionBinding(event, input)) {
              emitEvent(getInputActionListenerList(action), event)
              // console.log('onMouseUp.isClick.isMatch.true.return')
              return
            }
          }
        }
      }

      setTouchStartEvent(null)
      setTouchStartPosition(null)
      touchDragList.length = 0
    }
    if (touchesLen < 2) {
      setLastTouchMoveEvent(null)
    }
  }

  function onTouchCancel() {
    const entityGridXY = getEntityGridXYV2()
    batch(() => {
      setLastTouchMoveEvent(null)
      setHoveredPosition(null)
      calculateDestPositionHoverPositionPaths(engine, entityGridXY)
      calculateDraftMoveAttackEstimates(engine)
    })
  }

  onElementEvent(elem, 'touchstart', onTouchStart, { passive: false })
  onElementEvent(elem, 'touchmove', onTouchMove, { passive: false })
  onElementEvent(elem, 'touchend', onTouchEnd)
  onElementEvent(elem, 'touchcancel', onTouchCancel)
}
